import api from "./axiosConfig";
import { BrandlistFilterRequest } from "./models/BrandlistRequest";

export const getAllBrandList = async () => {
  return api.get('/brand/all');
}

export const getBrandList = async (page: number, limit: number) => {
  return api.get(`/brand/${page}?take=${limit}`);
}

export const getUserOptions = async () => {
  return api.get("/user")
}

export const getBrandlistWithFilters = async (page: number, limit: number, req: BrandlistFilterRequest) => {
  return api.post(`/brand/filter/${page}?take=${limit}`, req)
}

export const getBrandInvoices = async (brandNo:string) => {
    return api.get(`/brand/${brandNo}/invoices`);
}

export const getDownloadData = async (page: number, limit: number) => {
  return api.get(`/brand/download/${page}?take=${limit}`)
}